function accordian() {
  const accordions = document.querySelectorAll(".accordian-wrap");

  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";

    // Scroll the accordion into view when opened
    if (screen.width < 992){
    setTimeout(() => {
      accordion.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 300); 
  }
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".accordian-title");
    const content = accordion.querySelector(".accordian-content");
    intro.onclick = () => {
      if (content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((a) => closeAccordion(a));
        openAccordion(accordion);
      }
    };
  });
}

accordian();

document.addEventListener("shopify:section:load", function (event) {
  accordian();
});

const accordians = document.querySelectorAll('.accordian-content');

accordians.forEach(drawer => {
  drawer.addEventListener('wheel', (e) => {
    // allow normal scroll inside sidebar
    e.stopPropagation();
  }, { passive: false });

  drawer.addEventListener('touchstart', (e) => {
    e.stopPropagation();
  }, { passive: false });

  drawer.addEventListener('touchmove', (e) => {
    e.stopPropagation();
  }, { passive: false });
});

